import type { SxProps } from '@mui/material';

import type { Theme } from 'hephaestus/core';
export const reconFlagsFiltersSeverityPillsRowSx: SxProps = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 1,
  alignItems: 'center',
};

export const reconFlagsFiltersToolbarSx: SxProps = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 1,
};

export const reconFlagsFiltersControlsGridSx: SxProps = {
  display: 'grid',
  gridTemplateColumns: {
    xs: '1fr',
    sm: 'repeat(2, minmax(0, 1fr))',
    md: 'minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(200px, 2fr)',
  },
  gap: 1.5,
  alignItems: 'flex-end',
};

export const getReconFlagsFiltersFieldShellSx = (theme: Theme): SxProps => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: '6px',
    bgcolor: String(theme.color.surface),
    '& fieldset': {
      borderColor: String(theme.color.outlineVariant),
    },
    '&:hover fieldset': {
      borderColor: String(theme.color.outline),
    },
    '&.Mui-focused fieldset': {
      borderColor: String(theme.color.primary),
    },
  },
});

export const getReconFlagsFiltersStateSelectSx = (theme: Theme): SxProps => ({
  ...getReconFlagsFiltersFieldShellSx(theme),
  '& .MuiSelect-select': { fontWeight: 700 },
});

export const getReconFlagsFiltersDefaultSelectSx = (theme: Theme): SxProps => ({
  ...getReconFlagsFiltersFieldShellSx(theme),
  '& .MuiSelect-select': { fontWeight: 500 },
});

export const getReconFlagsFiltersSearchWrapperSx = (): SxProps => ({
  gridColumn: { xs: '1 / -1', sm: '1 / -1', md: 'auto' },
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  minWidth: 0,
});

export const getReconFlagsFiltersSearchFieldSx = (theme: Theme): SxProps => ({
  ...getReconFlagsFiltersFieldShellSx(theme),
  flex: 1,
  minWidth: 0,
  height: 'fit-content',
  bgcolor: 'transparent',
  '& .MuiAutocomplete-root': {
    height: 'fit-content',
    bgcolor: 'transparent',
  },
  '& .MuiFormControl-root': {
    height: 'fit-content',
    bgcolor: 'transparent',
  },
  '& input': { fontWeight: 500 },
  '& input::placeholder': {
    fontStyle: 'italic',
    opacity: 1,
    color: String(theme.color.onSurfaceVariant),
  },
});

export const severityFilterPillLabelSx: SxProps = {
  fontWeight: 500,
  color: 'inherit',
  lineHeight: 1.2,
};

export type SeverityFilterPillRootSxParams = {
  theme: Theme;
  active: boolean;
  activeBg: string;
  activeHoverBg: string;
  inactiveBorderAndText: string;
  interactive: boolean;
};

export const getSeverityFilterPillRootSx = ({
  theme,
  active,
  activeBg,
  activeHoverBg,
  inactiveBorderAndText,
  interactive,
}: SeverityFilterPillRootSxParams): SxProps => ({
  display: 'inline-flex',
  alignItems: 'center',
  px: 2,
  py: 1,
  borderRadius: 999,
  border: '1px solid',
  borderColor: active ? 'transparent' : inactiveBorderAndText,
  bgcolor: active ? activeBg : String(theme.color.surface),
  color: active ? String(theme.color.onPrimary) : inactiveBorderAndText,
  cursor: interactive ? 'pointer' : 'default',
  fontFamily: theme.font.base,
  transition:
    'background-color 120ms ease, border-color 120ms ease, color 120ms ease',
  ...(interactive
    ? {
        appearance: 'none',
        WebkitAppearance: 'none',
        font: 'inherit',
        textAlign: 'inherit',
        '&:hover': active
          ? { bgcolor: activeHoverBg }
          : { bgcolor: String(theme.color.neutralHover) },
      }
    : {}),
});
